import React from 'react';
import { useIntegerSort } from '../../hooks/useIntegerSort';
import CodeBlock from '../ui/CodeBlock';
import ResultBox from '../ui/ResultBox';
import TestCase from '../ui/TestCase';
import styles from './Exercise.module.css';

const CODE = `<span class="token-kw">function</span> <span class="token-fn">integerSort</span>(inputArray) {
  <span class="token-cm">// Copia para no modificar el original</span>
  <span class="token-kw">const</span> result = [...inputArray];

  <span class="token-kw">for</span> (<span class="token-kw">let</span> i <span class="token-op">=</span> <span class="token-num">0</span>; i <span class="token-op">&lt;</span> result.length <span class="token-op">-</span> <span class="token-num">1</span>; i<span class="token-op">++</span>) {
    <span class="token-kw">for</span> (<span class="token-kw">let</span> j <span class="token-op">=</span> <span class="token-num">0</span>; j <span class="token-op">&lt;</span> result.length<span class="token-op">-</span>i<span class="token-op">-</span><span class="token-num">1</span>; j<span class="token-op">++</span>) {

      <span class="token-cm">// Intercambio si están en orden incorrecto</span>
      <span class="token-kw">if</span> (result[j] <span class="token-op">&gt;</span> result[j <span class="token-op">+</span> <span class="token-num">1</span>]) {
        <span class="token-kw">let</span> temp    = result[j];
        result[j]     = result[j <span class="token-op">+</span> <span class="token-num">1</span>];
        result[j <span class="token-op">+</span> <span class="token-num">1</span>] = temp;
      }
    }
  }

  <span class="token-kw">return</span> result;
}`;

function IntegerSortExercise() {
  const { input, handleChange, parsed, sorted, isValid, testResults } = useIntegerSort();

  return (
    <div className={styles.exercise}>
      <div className={styles.split}>
        <div className={styles.codeCol}>
          <p className={styles.colLabel}>Implementación</p>
          <CodeBlock code={CODE} />
        </div>

        <div className={styles.playCol}>
          <p className={styles.colLabel}>Prueba</p>

          <div className={styles.field}>
            <label className={styles.inputLabel} htmlFor="is-input">
              Números separados por comas
            </label>
            <input
              id="is-input"
              className={styles.input}
              type="text"
              placeholder="Ej: 5, -2, 10, 0, 3, -7"
              value={input}
              onChange={(e) => handleChange(e.target.value)}
            />
            <span className={styles.hint}>Mínimo 2 enteros separados por coma</span>
          </div>

          <ResultBox
            label="Arreglo ordenado"
            value={isValid ? `[${sorted.join(', ')}]` : null}
            variant={isValid ? 'ok' : 'neutral'}
          />

          <ResultBox
            label="Original sin cambios"
            value={isValid ? `[${parsed.join(', ')}]` : null}
            variant="neutral"
          />
        </div>
      </div>

      <div className={styles.tests}>
        <p className={styles.testsLabel}>Casos de prueba del enunciado</p>
        <div className={styles.testsList}>
          {testResults.map((tc, i) => (
            <TestCase
              key={i}
              inputLabel={`[${tc.input.join(', ')}]`}
              expectedLabel={`[${tc.expected.join(', ')}]`}
              actualLabel={`[${tc.actual.join(', ')}]`}
              pass={tc.pass}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default IntegerSortExercise;
